import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AsVo } from "src/vo/asVo";

const initialState: AsVo = {
  progress: 0,
  isOnFocus: false,
  writeName: "",
  asCommentIdx: "",
};

const asDetailSlice = createSlice({
  name: "asDetail",
  initialState,
  reducers: {
    setOnFocusReduce: (state, action: PayloadAction<boolean>) => {
      state.isOnFocus = action.payload;
    },
    setWriteNameReduce: (state, action: PayloadAction<Array<string>>) => {
      // state.writeName = action.payload;
      if (action.payload.length > 0) {
        state.writeName = action.payload[0];
        state.asCommentIdx = action.payload[1];
      }
    },
  },
});

export const { setOnFocusReduce, setWriteNameReduce } = asDetailSlice.actions;
// 3-2. export default slice.reducer
export default asDetailSlice.reducer;
